import { render, staticRenderFns } from "./SalesOrderStatusNotPosted.vue?vue&type=template&id=26a80acf&"
import script from "./SalesOrderStatusNotPosted.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusNotPosted.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusNotPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports